import axiosClient from './axiosClient';

// Interface representing a submitted ticket/contact message
export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  message: string;
  createdAt: string;
  status: 'PENDING' | 'RESOLVED';
}

// Payload sent by the user from the Contact Dialog
export interface CreateContactPayload {
  name: string;
  email: string;
  message: string;
}

// 1. Public API: Submit contact form
export const submitContactFormApi = async (
  payload: CreateContactPayload
): Promise<void> => {
  return axiosClient.post('/support/contact', payload);
};

// 2. Admin API: Get all contact messages
export const getAllContactMessagesApi = async (): Promise<
  ContactMessage[] | null
> => {
  const res = await axiosClient.get('/support/admin/contacts');
  // Adjust based on your API structure (e.g., res.data or res.data.items)
  return res.data?.items ?? res.data ?? null;
};

export const replyToContactMessageApi = async (
  id: number,
  replyText: string
): Promise<{ success: boolean; item: { id: number; status: 'RESOLVED' } }> => {
  return axiosClient.post(`/support/admin/contacts/${id}/reply`, { replyText });
};
